var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { AAVEIcon, CompoundIcon, DDEXIcon, DYDXIcon, OasisIcon, } from "../../../assets/icons/defiApp";
import Logo from "../../../assets/icons/logo";
import { getAssets, } from "../../../constants/constants";
import { BaseText, Title } from "../../../designSystem";
import colors from "../../../designSystem/colors";
import theme from "../../../designSystem/theme";
import useLatestAPY from "../../../hooks/useLatestAPY";
import useLoadingText from "../../../hooks/useLoadingText";
import { getAssetDisplay } from "../../../utils/asset";
var YieldComparisonCard = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  border-radius: ", ";\n  background-color: ", ";\n  padding: 8px;\n  margin-top: 8px;\n"], ["\n  display: flex;\n  width: 100%;\n  border-radius: ", ";\n  background-color: ", ";\n  padding: 8px;\n  margin-top: 8px;\n"])), theme.border.radius, function (props) { return props.background; });
var YieldComparisonTitle = styled(BaseText)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", "A3;\n  width: 100%;\n  font-size: 12px;\n  margin-top: 24px;\n\n  &:first-child {\n    margin-top: 14px;\n  }\n"], ["\n  color: ", "A3;\n  width: 100%;\n  font-size: 12px;\n  margin-top: 24px;\n\n  &:first-child {\n    margin-top: 14px;\n  }\n"])), colors.primaryText);
var YieldComparison = function (_a) {
    var vault = _a.vault, vaultVersion = _a.vaultVersion, _b = _a.config, config = _b === void 0 ? {
        background: colors.background.three,
    } : _b, yieldInfos = _a.yieldInfos;
    var asset = getAssets(vault);
    var t = useTranslation().t;
    var latestAPY = useLatestAPY(vault, vaultVersion);
    var loadingText = useLoadingText();
    var perfStr = latestAPY.fetched
        ? latestAPY.res.toFixed(2) + "%"
        : loadingText;
    var renderProtocolLogo = useCallback(function (protocol) {
        switch (protocol) {
            case "aave":
                return _jsx(AAVEIcon, { height: "24", width: "24" }, void 0);
            case "compound":
                return _jsx(CompoundIcon, { height: "24", width: "24" }, void 0);
            case "ddex":
                return _jsx(DDEXIcon, { height: "24", width: "24" }, void 0);
            case "dydx":
                return (_jsx(DYDXIcon, { height: "24", width: "24", style: { borderRadius: "100px" } }, void 0));
            case "mcd":
                return _jsx(OasisIcon, { height: "24", width: "24" }, void 0);
        }
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(YieldComparisonTitle, { children: "Current Projected Yield (APY)" }, void 0), _jsxs(YieldComparisonCard, __assign({ background: config.background }, { children: [_jsx(Logo, { height: "24", width: "24" }, void 0), _jsx(Title, __assign({ fontSize: 14, lineHeight: 24, className: "ml-2" }, { children: t("shared:ProductCopies:" + vault + ":title") }), void 0), _jsx(Title, __assign({ fontSize: 14, lineHeight: 24, className: "ml-auto" }, { children: perfStr }), void 0)] }), void 0), _jsxs(YieldComparisonTitle, { children: ["Market ", getAssetDisplay(asset), " Yields (APY)"] }, void 0), yieldInfos
                .slice(0, 3)
                .map(function (_a) {
                var protocol = _a.protocol, apr = _a.apr;
                if (apr < 0.01) {
                    return null;
                }
                return (_jsxs(YieldComparisonCard, __assign({ background: config.background }, { children: [renderProtocolLogo(protocol), _jsx(Title, __assign({ fontSize: 14, lineHeight: 24, className: "ml-2" }, { children: protocol }), void 0), _jsx(Title, __assign({ fontSize: 14, lineHeight: 24, className: "ml-auto" }, { children: apr.toFixed(2) + "%" }), void 0)] }), protocol));
            })] }, void 0));
};
export default YieldComparison;
var templateObject_1, templateObject_2;
//# sourceMappingURL=YieldComparison.js.map